import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

interface AccessCodesTooltipProps {
  openLeft: boolean
}

const AccessCodesTooltip: React.FC<AccessCodesTooltipProps> = (
  props,
): React.ReactElement => {
  return (
    <Tooltip openLeft={props.openLeft}>
      <p>
        <Trns
          source={
            '${accessCodes} is code that is created and associated with this profile for each credit card the customer wants to register. It is not credit card-specific, but each one needs to be checked off when used to register a credit card.'
          }
          expressions={{
            accessCodes: (
              <span
                css={css`
                  font-family: ${styleConstants.fontFamilies.medium};
                `}
              >
                <Trns source={'Access code'} />
              </span>
            ),
          }}
        />
      </p>
    </Tooltip>
  )
}

export default AccessCodesTooltip
